import classNames from "classnames";
import React from "react";
import {
  SanityFormProps,
  SanityFormType,
  SanityPriceCalculationFormProps
} from "../models/form/SanityFormProps";
import { isNullOrWhiteSpace, replaceWithUnicode } from "../shared/string";
import SanityForm from "./Form/SanityForm";
import SanityPriceCalculatorForm from "./Form/SanityPriceCalculatorForm";
import StepByStep from "./StepByStep";
import Tab from "./Tab";
import Tabs from "./Tabs";

export type FormSectionProps = {
  forms?: (SanityFormProps | SanityPriceCalculationFormProps)[];
  stepByStepTitle?: string;
  stepBySteps?: string[];
  title?: string;
};

const FormSection = ({
  forms: sanityForms,
  stepBySteps,
  stepByStepTitle,
  title
}: FormSectionProps) => {
  const forms = sanityForms?.filter(form => !!form?.slug?.current);

  if (!forms?.length) {
    return null;
  }

  const isSinglePriceForm =
    forms.length === 1 && forms[0]._type === SanityFormType.PriceForm;

  const hasStepBySteps = !isNullOrWhiteSpace(stepByStepTitle) && !!stepBySteps?.length;

  const asideClasses = classNames({
    "max-w-3xl": !hasStepBySteps,
    "bg-form-bg": isSinglePriceForm && !hasStepBySteps
  });
  const formClasses = classNames(
    "px-4 pt-2 pb-8 mb-12 lg:mb-8 lg:px-32 lg:py-12 bg-form-bg border border-form-border rounded-lg shadow-lg",
    hasStepBySteps ? "w-full lg:flex-1 lg:w-2/3" : "w-full"
  );

  return (
    <aside className={asideClasses}>
      <span id="form" aria-hidden className="relative left-0 -top-24" />

      {!isNullOrWhiteSpace(title) && <h2>{replaceWithUnicode(title)}</h2>}

      {isSinglePriceForm && !hasStepBySteps ? (
        <div className="mt-2 px-2 sm:px-0">
          <SanityPriceCalculatorForm {...forms[0]} />
        </div>
      ) : (
        <div className="flex flex-wrap justify-center">
          <div className={formClasses}>
            <Tabs>
              {forms.map(form => (
                <Tab key={form.slug.current} id={form.slug.current} title={form.title}>
                  {form._type === SanityFormType.PriceForm ? (
                    <SanityPriceCalculatorForm {...form} />
                  ) : (
                    <SanityForm {...form} />
                  )}
                </Tab>
              ))}
            </Tabs>
          </div>

          {hasStepBySteps && (
            <StepByStep title={stepByStepTitle!} stepBySteps={stepBySteps!} />
          )}
        </div>
      )}
    </aside>
  );
};

export default FormSection;
